import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { RoleRedirectGuard } from './guards/role-redirect.guard';
import { AuthGuard } from './guards/auth.guard';

export const appRoutes: VexRoutes = [
  // Redirigir cualquier intento de acceder a login antiguo a Keycloak
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'customer-login',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'catalogo',
    loadComponent: () =>
      import('./modules/public-catalog/public-catalog.component').then(
        (m) => m.PublicCatalogComponent
      )
  },
  {
    path: 'aviso-de-privacidad',
    loadComponent: () =>
      import('./modules/public-privacy/public-privacy.component').then(
        (m) => m.PublicPrivacyComponent
      )
  },
  {
    path: 'eliminar-cuenta',
    loadComponent: () =>
      import('./modules/public-delete-account/public-delete-account.component').then(
        (m) => m.PublicDeleteAccountComponent
      )
  },
  {
    path: 'customer-dashboard',
    canActivate: [AuthGuard, RoleRedirectGuard],
    loadComponent: () =>
      import('./modules/customer/customer-dashboard/customer-dashboard.component').then(
        (m) => m.CustomerDashboardComponent
      )
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard, RoleRedirectGuard],
    children: [
      {
        path: 'administrativo',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('./modules/administrativo/administrativo.module').then(
                (m) => m.AdministrativoModule
              )
          },
          {
            path: 'table-materials',
            loadChildren: () =>
              import('./modules/table-materials/table-materials.module').then(
                (m) => m.TableMaterialsModule
              )
          },
          {
            path: 'table-pieces',
            loadChildren: () =>
              import('./modules/table-pieces/table-pieces.module').then(
                (m) => m.TablePiecesModule
              )
          },
          {
            path: 'optimizer',
            loadChildren: () =>
              import('./modules/optimizer/optimizer.module').then(
                (m) => m.OptimizerModule
              )
          }
        ]
      },
      {
        path: 'personal',
        loadChildren: () =>
          import('./modules/personal/personal.module').then(
            (m) => m.PersonalModule
          )
      },
      {
        path: 'employee-schedules',
        loadChildren: () =>
          import('./modules/employee-schedules/employee-schedules.module').then(
            (m) => m.EmployeeSchedulesModule
          )
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./modules/chat/chat.module').then(
            (m) => m.ChatModule
          )
      },
      {
        path: 'asignaciones',
        loadChildren: () =>
          import('./modules/asignaciones/asignaciones.module').then(
            (m) => m.AsignacionesModule
          )
      },
      {
        path: 'documentos',
        loadChildren: () =>
          import('./modules/documentos/documentos.module').then(
            (m) => m.DocumentosModule
          )
      },
      {
        path: 'calendario',
        loadChildren: () =>
          import('./modules/calendario/calendario.module').then(
            (m) => m.CalendarioModule
          )
      },
      {
        path: 'iam',
        loadChildren: () =>
          import('./modules/iam/iam.module').then((m) => m.IamModule),
      },
      {
        path: '',
        redirectTo: 'administrativo/pedidos-pendientes',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
